'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/secondAgo.js
// module id = 204
// module chunks = 0